export const PAYMENT_URL = "https://mensen.xpaycheckout.com/v2/mensen";
export const WHATSAPP_URL = "https://wa.me/447551283304";
export const CONTACT = {
  email: "support@myhomeworkassist.online",
  phone: "020 7362 6786",
  whatsapp: "+44 7551 283304",
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Pricing", href: "#pricing" },
  { label: "Samples", href: "#samples" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#quote" },
];

export const COUNTRIES = [
  "United Kingdom", "United States", "Canada", "Australia", "Germany",
  "France", "Dubai (UAE)", "Saudi Arabia", "Italy", "Jordan", "Qatar",
  "Ireland", "New Zealand", "Netherlands", "Oman", "Kuwait",
];

export const SERVICES = [
  {
    title: "Assignment Support",
    desc: "Well-researched, properly referenced assignments built around your brief, rubric and deadline — from first outline to final draft.",
    tag: "Most Ordered",
    image: "https://images.pexels.com/photos/7054785/pexels-photo-7054785.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Dissertation Support",
    desc: "Chapter-by-chapter guidance: proposal, literature review, methodology, analysis and the final polish that earns a First.",
    tag: "PhD Mentors",
    image: "https://images.pexels.com/photos/256541/pexels-photo-256541.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Thesis Support",
    desc: "Structured thesis planning, argument development and academic writing support for Masters and doctoral researchers.",
    tag: "Masters & PhD",
    image: "https://images.pexels.com/photos/159711/books-bookstore-book-reading-159711.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Research Proposal Guidance",
    desc: "Sharp, focused proposals with clear research questions, methodology justification and realistic timelines.",
    tag: "Fast Approval",
    image: "https://images.pexels.com/photos/256455/pexels-photo-256455.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Proofreading & Editing",
    desc: "Already written? We refine grammar, flow, structure and referencing — Harvard, APA, OSCOLA and more — to distinction standard.",
    tag: "Distinction Polish",
    image: "https://images.pexels.com/photos/8085262/pexels-photo-8085262.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Presentation & Poster Support",
    desc: "Conference posters, seminar slides and presentation scripts that communicate your research with clarity and style.",
    tag: "Visual & Verbal",
    image: "https://images.pexels.com/photos/261909/pexels-photo-261909.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const JOURNEY = [
  { num: "01", title: "Share Your Brief", desc: "Send your assignment brief, rubric and deadline — upload the file or fill the 60-second quote form." },
  { num: "02", title: "Get a Quote", desc: "Receive a transparent, fixed price within 15 minutes — no hidden fees, no obligation." },
  { num: "03", title: "Discuss Requirements", desc: "We match you with a degree-holding specialist in your subject and confirm every detail together." },
  { num: "04", title: "Receive Academic Support", desc: "Your expert researches, writes and refines your work — with progress updates along the way." },
  { num: "05", title: "Final Review", desc: "Receive your paper with a free originality report. Request free revisions until you're confident." },
];

export const TRUST_STATS = [
  { value: "15,000+", label: "Projects Completed" },
  { value: "500+", label: "Universities Covered" },
  { value: "100+", label: "Subjects & Courses" },
  { value: "4.9/5", label: "Average Student Rating" },
  { value: "<15 min", label: "Average Response Time" },
  { value: "100%", label: "Confidential & Secure" },
];

export const UNIVERSITY_SECTIONS = [
  {
    country: "United Kingdom",
    blurb: "Harvard & OSCOLA referencing, UK marking rubrics, and Russell Group standards — our UK specialists know exactly what your markers expect.",
    universities: ["University of Manchester", "University of Leeds", "King's College London", "University of Birmingham", "University of Glasgow", "UCL", "University of Edinburgh", "University of Nottingham"],
    courses: ["Business & Management", "Nursing", "Law", "Engineering", "Computer Science", "Finance"],
  },
  {
    country: "Germany",
    blurb: "Support for English-taught programmes across Germany — from TU Munich engineering modules to business degrees at Berlin's universities.",
    universities: ["TU Munich", "LMU Munich", "Heidelberg University", "RWTH Aachen", "Humboldt University Berlin", "University of Freiburg"],
    courses: ["Engineering", "Data Science", "Business Administration", "Natural Sciences", "Economics"],
  },
  {
    country: "Australia",
    blurb: "HD-standard support aligned with Group of Eight expectations — APA referencing, reflective practice and case-based assessments.",
    universities: ["University of Melbourne", "University of Sydney", "Monash University", "UNSW Sydney", "University of Queensland", "RMIT University"],
    courses: ["Nursing & Midwifery", "Accounting", "Information Technology", "Marketing", "Civil Engineering"],
  },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "Written by Humans. Only Humans.",
    desc: "Every paper is researched and written from scratch by a qualified academic writer — never generated, never spun, never recycled. We back this with a free AI-detection report on request.",
  },
  {
    num: "02",
    title: "Originality You Can Prove",
    desc: "Each order passes through premium plagiarism screening before delivery. You receive a complimentary originality report so you can submit with total confidence.",
  },
  {
    num: "03",
    title: "A Writer Who Knows Your Subject",
    desc: "Your work is matched to a writer holding a degree in your field — from nursing and law to engineering, finance and literature. Subject expertise is not optional here.",
  },
  {
    num: "04",
    title: "On Time, Every Time",
    desc: "Deadlines are sacred. Whether your paper is due in 14 days or 24 hours, we plan backwards from your submission date and deliver early wherever possible.",
  },
];

export const SUBJECTS = [
  "Management & MBA", "Nursing & Healthcare", "Law", "Engineering",
  "Computer Science & IT", "Finance & Accounting", "Economics", "Marketing",
  "Psychology", "Sociology", "English Literature", "Statistics",
  "Mathematics", "Human Resources", "History", "Political Science",
  "Education", "Biology & Life Sciences", "Chemistry", "Physics",
  "Hospitality & Tourism", "Media & Communication", "Philosophy", "Architecture",
];

export const FALLBACK_REVIEWS = [
  { name: "Hannah M.", meta: "MSc Management — London, UK", rating: 5,
    quote: "My dissertation chapters came back beautifully structured and fully referenced in Harvard style. The writer clearly understood my topic better than I did." },
  { name: "Omar A.", meta: "MBA Student — Dubai, UAE", rating: 5,
    quote: "I was sceptical about online help, but the originality report and the quality of research won me over. Delivered two days before my deadline." },
  { name: "Jessica T.", meta: "Nursing — Toronto, Canada", rating: 5,
    quote: "The support team replied on WhatsApp within minutes, even at midnight. My reflective essay scored a distinction. Worth every penny." },
  { name: "Lucas R.", meta: "Engineering — Melbourne, Australia", rating: 5,
    quote: "Clear calculations, clean report formatting and zero plagiarism. This is the only service I trust with my coursework now." },
];

export const FAQS = [
  {
    q: "How does the support process work?",
    a: "Five simple steps: share your brief (upload it or fill our 60-second form), receive a fixed quote within 15 minutes, discuss requirements with your matched expert, receive your academic support with progress updates, then review the final work with free revisions included.",
  },
  {
    q: "How do I submit my brief?",
    a: "Use the 'Upload Your Brief' section to send us your assignment file (PDF, DOC or DOCX) along with your university, course and deadline. You can also send it directly on WhatsApp — whichever is easier for you.",
  },
  {
    q: "How quickly can I receive a quotation?",
    a: "Our average response time is under 15 minutes during working hours, and we operate 24/7. Urgent 24-hour deadline? Message us on WhatsApp for an instant confirmation.",
  },
  {
    q: "What types of academic support are available?",
    a: "Assignment support, dissertation and thesis guidance, research proposal development, proofreading & editing, presentations and posters, case studies, reports and coursework — across 100+ subjects from nursing and law to engineering and finance.",
  },
  {
    q: "Is proofreading and editing available?",
    a: "Yes. If you've already written your work, our editors refine grammar, structure, flow, academic tone and referencing (Harvard, APA, OSCOLA, MLA and more) to distinction standard — usually within 24–48 hours.",
  },
  {
    q: "Can I receive dissertation guidance?",
    a: "Absolutely. Dissertation support is one of our most requested services. We guide you chapter by chapter — proposal, literature review, methodology, analysis and conclusion — with PhD-qualified mentors in your field.",
  },
  {
    q: "Is the work AI-free and plagiarism-free?",
    a: "Yes. Everything is written from scratch by human academic writers and screened with premium plagiarism and AI-detection tools before delivery. You receive a free originality report with every order.",
  },
  {
    q: "How is my information kept private?",
    a: "Completely confidentially. Your identity, documents and order details are never shared with third parties, universities or other students. Communication stays between you, our support team and your assigned expert.",
  },
  {
    q: "How can I contact the support team?",
    a: "WhatsApp us at +44 7551 283304 (fastest), email support@myhomeworkassist.online, or call 020 7362 6786. We reply within minutes, 24/7 — including weekends and holidays.",
  },
];

export const ASSIGNMENT_TYPES = [
  "Essay", "Assignment", "Dissertation", "Thesis", "Research Proposal",
  "Coursework", "Case Study", "Report", "Presentation / Poster", "Proofreading / Editing", "Other",
];

export const SUPPORT_TYPES = [
  "Assignment Support", "Dissertation Support", "Thesis Support",
  "Research Proposal Guidance", "Proofreading & Editing", "Presentation & Poster Support",
];

export const FIND_SUPPORT = {
  countries: ["United Kingdom", "Germany", "Australia", "United States", "Canada", "UAE (Dubai)", "Saudi Arabia", "Qatar", "Other"],
  universities: {
    "United Kingdom": ["University of Manchester", "University of Leeds", "King's College London", "University of Birmingham", "University of Glasgow", "UCL", "University of Edinburgh", "University of Nottingham", "Other UK University"],
    "Germany": ["TU Munich", "LMU Munich", "Heidelberg University", "RWTH Aachen", "Humboldt University Berlin", "University of Freiburg", "Other German University"],
    "Australia": ["University of Melbourne", "University of Sydney", "Monash University", "UNSW Sydney", "University of Queensland", "RMIT University", "Other Australian University"],
  },
  courses: ["Business & Management", "Nursing & Healthcare", "Law", "Engineering", "Computer Science & IT", "Finance & Accounting", "Economics", "Marketing", "Psychology", "Education", "Other"],
};

export const FALLBACK_LEVELS = [
  { value: "high-school", label: "High School", rate250: 7.5 },
  { value: "undergraduate", label: "Undergraduate", rate250: 10 },
  { value: "masters", label: "Masters / MBA", rate250: 12.5 },
  { value: "phd", label: "PhD / Doctoral", rate250: 15 },
];

export const FALLBACK_DEADLINES = [
  { value: "24h", label: "24 Hours", multiplier: 1.8 },
  { value: "3d", label: "3 Days", multiplier: 1.4 },
  { value: "7d", label: "7 Days", multiplier: 1.15 },
  { value: "14d", label: "14+ Days", multiplier: 1.0 },
];

export const ORDER_SERVICES = SUPPORT_TYPES;

export const CALC_SUBJECTS = [
  "Management & MBA", "Nursing & Healthcare", "Law", "Engineering",
  "Computer Science & IT", "Finance & Accounting", "Economics", "Marketing",
  "Humanities & Social Sciences", "Other",
];

export const COUNTRY_OPTIONS = [
  { code: "GB", label: "United Kingdom" },
  { code: "US", label: "United States" },
  { code: "CA", label: "Canada" },
  { code: "AU", label: "Australia" },
  { code: "DE", label: "Germany" },
  { code: "FR", label: "France" },
  { code: "AE", label: "United Arab Emirates (Dubai)" },
  { code: "SA", label: "Saudi Arabia" },
  { code: "IT", label: "Italy" },
  { code: "JO", label: "Jordan" },
  { code: "QA", label: "Qatar" },
  { code: "IE", label: "Ireland" },
  { code: "NZ", label: "New Zealand" },
  { code: "NL", label: "Netherlands" },
];
